/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Upload_Creating_UrlInputs */

const en_toast_upload_creating_url = /** @type {(inputs: Toast_Upload_Creating_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating URL`)
};

const es_toast_upload_creating_url = /** @type {(inputs: Toast_Upload_Creating_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando URL`)
};

/**
* | output |
* | --- |
* | "Creating URL" |
*
* @param {Toast_Upload_Creating_UrlInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_upload_creating_url = /** @type {((inputs?: Toast_Upload_Creating_UrlInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Upload_Creating_UrlInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_upload_creating_url(inputs)
	return en_toast_upload_creating_url(inputs)
});